import React from "react";

import { Button, Col, Row } from "react-bootstrap";
import Company from "./Company";
import Loader from "react-loader-spinner";
//import { isA, isReporter } from "../../store/utility";
//import Switch from "rc-switch";

export default class Companies extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      backupData: null,
      rowId: null,
      editingId: null,
      showInactive: false
    };
  }

  //LifeCycle
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data,
        backupData: nextProps.data
      });
    }
  }
  addCompanyHandler = event => {
    event.preventDefault();
    var _state = this.state;
    _state.addCompany = true;
    this.setState(_state);
  };

  hideCompanyHandler = event => {
    event.preventDefault();
    var _state = this.state;
    _state.addCompany = false;
    this.setState(_state);
  };
  //UI methods

  saveOrUpdate = company => {
    this.props.saveOrUpdate(company);
    var _state = this.state;
    _state.addCompany = false;
    _state.editingId = null;
    this.setState(_state);
  };

  buildRows = editingId => {
    const data = this.props.data;
    //console.log("NB COMPAGNIES : " + data.length);
    // 22/10/2026 : clients desactives masques sauf si l'interrupteur est active
    var companies = this.state.showInactive ? data : data.filter(c => c.activated !== false);
    var rows = [];
    var nbRows = 0;
    for (var k = 0; k < companies.length; k += 3) {
      nbRows++;
      rows.push(
        <Row key={nbRows * 53}>
          <Col sm={4}>
            <Company
              key={companies[k].id}
              data={companies[k]}
              editing={editingId === companies[k].id}
              disableOthersEditing={this.disableOthersEditing}
              saveOrUpdate={company => this.saveOrUpdate(company)}
            />
          </Col>
          {k + 1 < companies.length ? (
            <Col sm={4}>
              <Company
                key={companies[k + 1].id}
                data={companies[k + 1]}
                editing={editingId === companies[k + 1].id}
                disableOthersEditing={this.disableOthersEditing}
                saveOrUpdate={company => this.saveOrUpdate(company)}
              />
            </Col>
          ) : null}
          {k + 2 < companies.length ? (
            <Col sm={4}>
              <Company
                key={companies[k + 2].id}
                data={companies[k + 2]}
                editing={editingId === companies[k + 2].id}
                disableOthersEditing={this.disableOthersEditing}
                saveOrUpdate={company => this.saveOrUpdate(company)}
              />
            </Col>
          ) : null}
        </Row>
      );
    }

    return rows;
  };

  disableOthersEditing = id => {
    this.setState({ editingId: id });
    this.forceUpdate();
  };

  render() {
    if (this.props.data === null || this.props.company === null) {
      return (<div align="center">
        <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
      </div>);
    }
    const editingId = this.state.editingId;
    var newCompany = {
      id: null,
      name: "",
      rcs: "",
      siret: "",
      sections: [],
      activated: true,
      dependOn: "ATIS_SYSTEM",
      repName: ""
    };

    return (
      <div>
        <Row style={{ paddingBottom: "20px" }}>
          <Col sm={12} className="pull-right">
            <label className="pull-left" style={{ fontWeight: "normal", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={this.state.showInactive}
                onChange={() => this.setState({ showInactive: !this.state.showInactive, editingId: null })}
              />
              &nbsp;Afficher les clients désactivés ({this.props.data.filter(c => c.activated === false).length})
            </label>
            <Button
              bsStyle="primary"
              bsSize="sm"
              className="pull-right"
              onClick={event => this.addCompanyHandler(event)}
            >
              <span className="fa fa-plus" />
              &nbsp;Nouvelle compagnie
            </Button>
          </Col>
        </Row>
        {this.state.addCompany ? (
          <Row>
            <Col sm={3} />
            <Col sm={6}>
              <Company
                data={newCompany}
                editing={true}
                disableOthersEditing={this.disableOthersEditing}
                saveOrUpdate={company => this.saveOrUpdate(company)}
                hideCompany={event => this.hideCompanyHandler(event)}
              />
            </Col>
            <Col sm={3} />
          </Row>
        ) : null}
        {this.buildRows(editingId)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Company/Companies.js